import React from "react";
import { Outlet } from "react-router-dom";

const Journal = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Outlet />
    </div>
  );
};

export default Journal;
